export default {
  props: {
    formatData: {
      type: Object,
      default: () => {}
    },
    basicData: {
      type: Object,
      default: () => {}
    },
    previewScale: {
      type: Number,
      default: 1
    },
    currentCardId: {
      type: [String, Array],
      default: ''
    },
    idPrefix: {
      type: String,
      default: ''
    },
    // サンプルデータを表示する用ジャンプなど無効化
    isSample: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      jumpId: 'default',
      cardChanged: false
    }
  },
  computed: {
    isCardChanged: function () {
      return this.cardChanged
    },
    scaleStyle: function () {
      return {
        transform: 'scale(' + this.previewScale + ')',
        'transform-origin': 'top left'
      }
    },
    highlightMessage: function () {
      if (this.$deviceLib.isMobileDevice) {
        return 'タップで編集'
      } else {
        return 'クリックで編集'
      }
    }
  },
  methods: {
    goCardTo: function (id) {
      if (this.isSample) return
      this.$eventHub.$emit('go-card-to', id)
    },
    setJumpId: function (jumpId) {
      // console.log('setJumpId:', jumpId)
      this.jumpId = jumpId
      this.$nextTick(function () {
        this.jumpId = ''
      })
      this.cardChanged = true
      setTimeout(
        () => {
          this.cardChanged = false
        },
        5000)
    },
    highLightClass: function (cardId) {
      if (this.isSample) return {}
      if (typeof cardId === 'string') {
        return {
          highlight: this.currentCardId === cardId && this.isCardChanged
        }
      } else if (Array.isArray(cardId)) {
        return {
          highlight: cardId.indexOf(this.currentCardId) !== -1 && this.isCardChanged
        }
      }
    }
  },
  beforeMount: function () {
    this.$eventHub.$on('show-preview-from-card', this.setJumpId)
  },
  destroyed: function () {
    this.$eventHub.$off('show-preview-from-card', this.setJumpId)
  }
}
